import { getLangUrlPart } from 'common/utils'

export function getDescriptionLink(promotion, translationKey, format, lang, t) {
  const {
    collectionId: { entry }
  } = promotion
  const slug = entry.find(item => item.key === lang).value.toLowerCase()

  return `${getLangUrlPart(format, lang)}/${t(translationKey, { slug })}`
}
